import { CaptionedMixinInterface } from "../../mixins/CaptionedMixinInterface";
import { Label } from "./Label";
import { LabelProps } from "./LabelProps";

export class CaptionLabel extends Label {
    private parentComponent: CaptionedMixinInterface;

    constructor(parentComponent: CaptionedMixinInterface, labelProps?: Partial<LabelProps>) {
        super(labelProps);
        this.parentComponent = parentComponent;
        this.setProps(this.parentComponent.captionLabelProps);
        this._designer = parentComponent._designer;
        this.alternateDesignerTarget = parentComponent;
        this.syncId();
    }

    public syncId() {
        this.id = this.parentComponent.createInnerComponentId("captionLabel");
    }
}
